import { Drawer } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { dimens } from '../shared-constants/dimens'
import { colors } from '../shared-constants/colors'
import { PaymentSection } from '../shared_components/style-components/Styles'
import { useLocation } from 'react-router-dom'

export const BottomDrawerContext = React.createContext({
  component: undefined,
  setComponent: (component) => {},
  refresh: false,
  eventCach: null,
  setEventCache: () => {},
  show: () => {},
  hide: () => {},
  title: '',
  setTitle: (title) => {},
  setMaxHeight: (key: string) => {},
  isShow: false,
})

const BottomDrawerProvider = (props) => {
  const [isShow, setShow] = useState(false)
  const [component, setComponent] = useState()
  const [eventCach, setEventCache] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const [title, setTitle] = useState('')
  const [maxHeight, setMaxHeight] = useState<string>('378px')

  const show = () => {
    setShow(true)
  }

  const destroyModal = () => {
    setShow(false)
    // setModalComponent(null);
  }

  const hide = useCallback(() => {
    destroyModal()
    setRefresh(!refresh)
  }, [])
  // hide drawer on route change
  const location = useLocation()
  useEffect(() => {
    hide()
  }, [location, hide])

  return (
    <BottomDrawerContext.Provider
      value={{
        eventCach,
        setEventCache,
        setComponent: setComponent,
        component: component,
        hide,
        show,
        refresh,
        setTitle,
        setMaxHeight,
        isShow,
      }}
    >
      {props.children}
      <CustomDrawer
        className='fit-width bottom-drawer'
        title={title}
        placement={'bottom'}
        closable={false}
        onClose={hide}
        open={isShow}
        maxHeight={maxHeight}
      >
        <Line />
        {component}
      </CustomDrawer>
    </BottomDrawerContext.Provider>
  )
}

export const DrawerContextConsumer = BottomDrawerContext.Consumer

export default BottomDrawerProvider

const CustomDrawer = styled(Drawer)<{ maxHeight: string }>`
  .ant-drawer-content {
    border-radius: ${dimens.BORDER_RADIUS_8} ${dimens.BORDER_RADIUS_8} 0 0 !important;
  }
  .ant-drawer-content-wrapper {
    /* height: unset !important; */
    max-height: ${(props) =>
      props.maxHeight} !important; /* Maximum height for large content */
    min-height: 100px !important; /* Minimum height for small content */
    height: auto !important; /* Allow the height to adjust dynamically */
    overflow-y: auto !important;
  }
  /* .ant-drawer-body {
    ${PaymentSection}
  } */
`

const Line = styled.div`
  position: absolute;
  top: 0.625rem;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 0.188rem;
  width: 3.438rem;
  background-color: ${colors.BLACK};
  opacity: 0.2;
  border-radius: ${dimens.BORDER_RADIUS_8};
`
